import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import NavBar from './components/NavBar/NavBar';
import Home from './Pages/Home/Home';
import AddBook from './Pages/AddBook/AddBook';
import EditBook from './Pages/EditBook/EditBook';
function App() {
  return (
    <div className="App">
      <Router>
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/addBook" element={<AddBook />} />
          <Route path="/editBook/:id" element={<EditBook />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
